<template>
  <div class="addtional-search-field">
    <div class="additona-field-label">
      <div>
        <UiDbField
          class="database-field"
          nontag
          v-for="(f, ind) in field.key.split(/~/)"
          :field="f"
          :key="ind"
        />
      </div>
      <div class="edit-icon">
        <UiButtonIcon
          tag="button"
          type="button"
          class="jps-icon-button jps-sub-orange"
          icon="mdi/pencil"
          @click="emits('edit', field.key)"
        />
        <UiButtonIcon
          tag="button"
          type="button"
          class="jps-icon-button jps-sub-orange"
          icon="mdi/close-circle"
          @click="emits('delete', field.key)"
        />
      </div>
    </div>
    <Component
      :is="searchFieldComponent(field)"
      :field="field"
      :ss="ss"
    />
  </div>
</template>

<script lang="ts" setup>
import { useSearchField } from '~/components/search/useSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { searchFieldComponent } = useSearchField()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const emits = defineEmits(['edit', 'delete'])
</script>

<style lang="scss" scoped>
.addtional-search-field {
  .additona-field-label {
    padding: 8px;
    display: flex;
    align-items: center;
    .database-field {
      font-size: 0.875rem;
      &:not(:last-child) {
        &:after {
          content: '/';
          margin-left: 0.25rem;
          margin-right: 0.25rem;
        }
      }
    }
    .edit-icon {
      margin-left: auto;
    }
  }
}
</style>
